import request from '@/utils/request'

// 战队列表（仅机构管理员）
export function unitList() {
  return request.post('/org/unitList')
}

// 战队新增/修改：POST id account name type contact phone password remark status
export function unitSave(data) {
  return request.post('/org/unitSave', data)
}

// 战队删除：POST id
export function unitDelete(id) {
  return request.post('/org/unitDelete', { id })
}

// 小组列表（可按 unit_id 过滤）
export function teamList(data) {
  return request.post('/org/teamList', data)
}

// 小组新增/修改：POST id unit_id account name type contact phone password remark status
export function teamSave(data) {
  return request.post('/org/teamSave', data)
}

// 小组删除：POST id
export function teamDelete(id) {
  return request.post('/org/teamDelete', { id })
}

// 员工列表（可按 unit_id/team_id 过滤）
export function staffList(data) {
  return request.post('/org/staffList', data)
}

// 员工新增/修改：POST id unit_id team_id account name phone password work_status is_leader wechat wechat_qrcode remark status
export function staffSave(data) {
  return request.post('/org/staffSave', data)
}

// 员工删除：POST id
export function staffDelete(id) {
  return request.post('/org/staffDelete', { id })
}

// 切换员工工作状态：POST id work_status(1正常 2休息)
export function staffWorkStatus(data) {
  return request.post('/org/staffWorkStatus', data)
}

// 设置销售员工每日接受推广上限：POST id daily_promo_limit(0=不限)
export function staffDailyLimit(data) {
  return request.post('/org/staffDailyLimit', data)
}

// 设置销售员工是否接受推广：POST id accept(0关闭 1开启)
export function staffFlowAccept(data) {
  return request.post('/org/staffFlowAccept', data)
}

/** 员工二维码列表：POST staff_id（仅销售员工） */
export function staffQrcodeList(staffId) {
  return request.post('/org/staffQrcodeList', { staff_id: staffId })
}

/** 新增/修改员工二维码：POST id staff_id type(1QQ 2微信) account qrcode status remark */
export function staffQrcodeSave(data) {
  return request.post('/org/staffQrcodeSave', data)
}

/** 删除员工二维码：POST id */
export function staffQrcodeDelete(id) {
  return request.post('/org/staffQrcodeDelete', { id })
}

/** 切换员工二维码启/停用：POST id status(0停用 1启用) */
export function staffQrcodeStatus(data) {
  return request.post('/org/staffQrcodeStatus', data)
}

// 小组流量配置列表：POST team_id
export function flowList(teamId) {
  return request.post('/org/flowList', { team_id: teamId })
}

// 保存流量配置：POST team_id + items
export function flowSave(data) {
  return request.post('/org/flowSave', data)
}
